import axios from '@/utils/axios'
import {platform, platformUserPrefix} from '@/api/common'

/**
 * 获取平台用户信息
 * @param NotNeedErrorMessage
 */
export const getPlatformUserInfo = (NotNeedErrorMessage = false) => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/user/getUserInfo`,
    headers: {
      ...(NotNeedErrorMessage ? {'NotNeedErrorMessage': true} : {})
    },
    method: 'get'
  })
}

/**
 * 添加平台用户信息
 * @param form
 */
export const addPlatformUser = form => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/user/addPlatformUser`,
    method: 'post',
    data: form
  })
}

/**
 * 修改平台用户信息
 * @param form
 */
export const editPlatformUser = form => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/user/editPlatformUser`,
    method: 'post',
    data: form
  })
}

/**
 * 平台用户信息列表
 * @param params
 */
export const platformUserTable = params => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/user/platformUserTable`,
    method: 'post',
    data: params
  })
}

/**
 * 删除平台户信息
 * @param userCodes 用户编码串
 */
export const removePlatformUser = (userCodes) => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/user/removePlatformUser`,
    method: 'delete',
    params: {userCodes}
  })
}



// WEBPACK FOOTER //
// ./src/api/platform/user/index.js